var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ViewSession',{key:_vm.sessionId,attrs:{"sessionId":_vm.sessionId,"labels":_vm.labels}})}
var staticRenderFns = []

export { render, staticRenderFns }